import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { removeAuthToken } from 'granite-admin/core/controllers/dashboardHeader';
const Logout = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    removeAuthToken();
    dispatch({
      type: 'accounts/user/RESET_STATE'
    });
    history.push('/');
  }, [dispatch, history]);
  return null;
};
export default Logout;